let globalSocket:any = null;

export const socketSetter = (socketData: any) => {
    globalSocket = socketData;
}

export const beforeUnloadHandler = (event: any) => {
    event.preventDefault();
    globalSocket?.close()
}